import React from 'react';
import './Footer.css';
import wsp from '../assets/images/wsp.png';
import instagram from '../assets/images/instagram.png';
import facebook from '../assets/images/facebook.png';
import youtube from '../assets/images/youtube.png';
import Modal from './Modal';

const Footer = () => {
  const [isMapModalOpen, setIsMapModalOpen] = React.useState(false);

  const openMapModal = () => {
    setIsMapModalOpen(true);
  };

  const closeMapModal = () => {
    setIsMapModalOpen(false);
  };

  return (
    <footer className="footer">
      <Modal 
        isOpen={isMapModalOpen} 
        onClose={closeMapModal}
        title="Ubicación CAIMA"
      >
        <iframe 
          title="Mapa de ubicación"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3644.4392833002387!2d-70.39549992374693!3d-23.65050047869791!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96afd5d4b2b7e45f%3A0x7f3d229fc506e709!2sGeneral%20Vel%C3%A1squez%20890%2C%20Antofagasta%2C%20Chile!5e0!3m2!1ses!2s!4v1701893155396!5m2!1ses!2s"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </Modal>
      <div>
        <div className="footer-content">
          <div className="footer-logo">
            <img src="/assets/images/caima.png" alt="CAIMA - Centro Avanzado de Implantología Maxilofacial" />
          </div>

          <div className="footer-info">
            <div className="info-row">
              <div className="direccion">
                <button 
                  className="direccion-btn"
                  onClick={openMapModal}
                >
                  <i className="fas fa-map-marker-alt"></i>
                  Dirección
                </button>
                <p>General Velásquez 890 Oficina 502, Edificio Carrera Antofagasta, Chile.</p>
              </div>

              <div className="contacto">
                <a href="mailto:contacto@caima.cl">contacto@caima.cl</a>
                <span className="separator">|</span>
                <a href="tel:552467204">552 467 204</a>
                <span className="separator">|</span>
                <a href="https://wa.link/1rzgex">+56 9 7871 2707</a>
              </div>

              <div className="social-media">
                <a href="https://www.instagram.com/caima_implantesdentales/" target="_blank" rel="noopener noreferrer">
                  <img src={instagram} alt="Instagram" />
                </a>
                <a href="https://wa.link/1rzgex" target="_blank" rel="noopener noreferrer">
                  <img src={wsp} alt="WhatsApp" />
                </a>
                <a href="https://www.facebook.com/caima.ltda.9" target="_blank" rel="noopener noreferrer">
                  <img src={facebook} alt="Facebook" />
                </a>
                <a href="https://www.youtube.com/@CAIMA_IMPLANTESDENTALES" target="_blank" rel="noopener noreferrer">
                  <img src={youtube} alt="YouTube" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>CAIMA® 2025 - Centro Avanzado de Implantología Maxilofacial | Diseñador Freelance</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 